// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.PDI-asnwers {
  display: grid;
  flex-wrap: wrap;
  gap: 4rem;
  padding: 1rem 0;
  justify-content: center;
  align-items: center;
  grid-template-columns: max-content;
}
@media screen and (min-width: 576px) {
.PDI-asnwers {
    grid-template-columns: max-content max-content;
}
}
@media screen and (min-width: 1400px) {
.PDI-asnwers {
    grid-template-columns: max-content max-content max-content max-content;
}
}
.PDI-asnwers .PDI-image-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  text-transform: uppercase;
  font-size: 12px;
}
.PDI-asnwers .PDI-image-wrapper .PDI-image {
  position: relative;
  display: block;
}
.PDI-asnwers .PDI-image-wrapper img {
  display: block;
}
.PDI-asnwers .PDI-point {
  --diameter: 30px;
  position: absolute;
  width: var(--diameter);
  height: var(--diameter);
  border-radius: 100px;
  transform: translate(-50%, -50%);
  background-color: #006EAB;
  opacity: 0.95;
}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
